<template>
    <div class="box">
        <img :src="imgObj[type]" alt="">
    </div>
</template>
<style lang="scss">
    .box {
        min-width: 100vw;
        min-height: 100vh;
        img {
            width: 100%;
        }
    }
</style>
<script>
    export default {
        data () {
            return {
                type: '',
                imgObj: {
                    jfrule: require('../../../assets/image/nsale/jf_rule.jpg'),
                    notify: require('../../../assets/image/nsale/notify.png'),
                    help: require('../../../assets/image/nsale/help.jpg'),
                }
                
            }
        },
        mounted() {
            this.type = this.$route.query.type
        }
    }
</script>